import styled from 'styled-components';

export const Wrapper = styled.div`
  position: fixed;
  border-radius: 5px;
  pointer-events: none;
`;
